export default function Success({ paymentType, handleAction, t }) {
  const key = paymentType === 'free' ? 'free' : 'paid';
  return (
    <div className='glass text-center mx-auto' style={{ maxWidth: '440px' }}>
      <i
        className='bi bi-check-circle-fill success-icon d-block mb-3'
        aria-hidden='true'
      />
      <h2 className='site-title'>{t(`success.${key}.title`)}</h2>
      <p className='text-body-secondary mb-4'>{t(`success.${key}.message`)}</p>
      <button
        type='button'
        className='btn btn-primary w-100'
        onClick={handleAction}
      >
        {t('success.home')}
      </button>
    </div>
  );
}
